<template>
  <div class="edit-cooperation-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>新增合作服务机构</h1>
        <p>业务区域管理</p>
      </div>
    </div>

    <!-- 表单 -->
    <div class="from-wrap">
      <div class="from-item mb_85">
        <div class="label"><span class="requird"></span>机构名称：</div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入机构名称，30个字符内"
            maxlength="30"
            v-model="params.svname"
          />
        </div>
      </div>
      <div class="from-item form-item-radio mb_75">
        <div class="label"><span class="requird"></span> 机构类型（单选）</div>
        <div class="radio-box flex-rowl">
          <div
            class="radio-item flex-rowl mb_30"
            v-for="(item, index) in svtypeList"
            :key="index"
            :class="{ active: params.svtype == item.value }"
            @click="handleRadio('svtype', item.value)"
          >
            {{item.label}}
          </div>
        </div>
      </div>
      <div class="from-item-address mb_75">
        <div class="tit">所属市区</div>
        <div class="txt">
          <p>省/直辖市：上海</p>
          <p>城市：上海</p>
        </div>
      </div>
      <div class="from-item mb_100">
        <div class="label"><span class="requird"></span>区域：</div>
        <div
          class="select-box flex-rowc"
          :class="{ 'has-value': areastr }"
          @click="handleShow"
        >
          {{ areastr ? areastr : "选择区域" }}
        </div>
      </div>
      <div class="from-item mb_110">
        <div class="label"><span class="requird"></span>详细地址：</div>
        <div class="textarea-box">
          <textarea placeholder="请填写详细地址，50个字符内" maxlength="50" v-model="params.addr" />
        </div>
      </div>
      <div class="from-item form-item-radio">
        <div class="label"><span class="requird"></span> 机构状态？</div>
        <div class="radio-box flex-rowc">
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.svstate === '1' }"
            @click="handleRadio('svstate', '1')"
          >
            启用
          </div>
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.svstate === '0' }"
            @click="handleRadio('svstate', '0')"
          >
            停用
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <div
        class="add-btn flex-rowc"
        :class="{ disanled: isSubmitting }"
        @click="handleSubmit"
      >
        确认·保存
      </div>
    </div>

    <!-- 选择区域 -->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '45%' }"
      ><van-picker
        title="选择区域"
        show-toolbar
        :columns="areaList"
        @confirm="onConfirm"
        @cancel="onCancel"
        value-key="addrname"
    /></van-popup>
  </div>
</template>

<script>
import { getArea } from "../../../api/public";
import { addService, editService, getServiceDetail } from "../../../api/api";
export default {
  name: "EditCooperationManagement",
  data() {
    return {
      // 参数
      params: {
        id: "",
        svname: "",
        svtype: '', // 服务机构类型 =1=三甲医院|2=普通医院|3=诊所|4=药房/药店|5=体验服务机构|
        province: 24, // 上海
        city: 456, // 上海市
        area: "",
        addr: '',  // 详细地址
        svstate: "", // 服务机构状态 =1=启用|0=停用|
      },
      areastr: "",
      // 区域列表
      areaList: [],
      isShow: false,

      // 机构类型列表
      svtypeList: [
        { value: '1', label: '三甲医院' },
        { value: '2', label: '普通医院' },
        { value: '3', label: '诊所' },
        { value: '4', label: '药房/药店' },
        { value: '5', label: '体验服务机构' },
      ],

      isSubmitting: false, // 提交中标记
    };
  },
  created() {
    this.getAreaList();
    console.log(this.$route.query, "====");

    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
      this.getServiceDetail();
    }
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      const res = await getArea(this.params.city);
      this.areaList = res;
    },

    // 获取服务机构详情
    async getServiceDetail() {
      const res = await getServiceDetail(this.params.id);
      try {
        this.params.svname = res.svname;
        this.params.svtype = res.svtype;
        this.params.area = res.area;
        this.params.addr = res.addr;
        this.params.svstate = res.svstate;
        this.areastr = res.areastr;
      } catch (error) {
        console.error("获取街道详情失败:", error);
        this.$toast.fail("获取街道详情失败，请稍后重试");
      }
    },

    // 触发单选框
    handleRadio(type, value) {
      this.params[type] = value;
    },

    // 显示区域
    handleShow() {
      this.isShow = true;
    },
    // 确认
    onConfirm(e) {
      this.params.area = e.addrid;
      this.areastr = e.addrname;
      this.onCancel();
    },
    // 取消
    onCancel() {
      this.isShow = false;
    },

    // 返回上一页
    handleBack() {
      this.$router.back();
    },

    // 提交
    async handleSubmit() {
      let { svname, svtype, area, addr, svstate } = this.params;
      if (!svname) {
        this.$toast("请输入机构名称");
        return;
      }
      if (!svtype) {
        this.$toast("请选择机构类型");
        return;
      }
      if (!area) {
        this.$toast("请选择区域");
        return;
      }
      if (!addr) {
        this.$toast("请输入详细地址");
        return;
      }
      if (!svstate) {
        this.$toast("请选择服务机构状态");
        return;
      }

      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 设置提交中标记
      this.isSubmitting = true;
      // 显示加载中提示
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res;
        if (this.params.id) {
          // params.id 存在，调用 editService 接口
          res = await editService(this.params);
        } else {
          // params.id 不存在，调用 addService 接口
          res = await addService(this.params);
        }

        if (res.result == "true") {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.$toast.success("提交成功");

          await new Promise((resolve) => setTimeout(resolve, 800));
          // 提交成功后返回上一页
          this.$toast.clear();
          this.$router.back();
          this.isSubmitting = false;
        } else {
          this.$toast.fail(res.message || "提交失败，请稍后重试");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$toast.fail("提交出错，请稍后重试");
        this.isSubmitting = false;
      } finally {
        // 无论成功或失败，都关闭加载提示并重置提交状态
        // this.$toast.clear();
        // this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.edit-cooperation-page {
  padding-bottom: 380px;
  box-sizing: border-box;
  /deep/.van-popup {
    max-width: 750px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 70px 0 98px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .from-wrap {
    width: 600px;
    margin: auto;
    .from-item {
      .label {
        position: relative;
        font-size: 26px;
        color: #333333;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 23px;
        .requird {
          width: 15px;
          height: 15px;
          background: url("../../../assets/images/required-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -12px;
        }
      }
      &.form-item-radio {
        .label {
          margin-bottom: 60px;
        }
      }
      .input-box,
      .select-box {
        border-bottom: 1px solid #c3c3c3;
        font-size: 24px;
        height: 52px;
        padding: 0 13px;
        box-sizing: border-box;
        input {
          height: 100%;
          width: 100%;
          background: none;
        }
      }
      .select-box {
        position: relative;
        border-bottom: 1px dashed #c3c3c3;
        padding-right: 20px;
        color: #aaaaaa;
        line-height: 52px;
        &.has-value {
          color: #333333;
        }
        input {
          text-align: center;
        }
        &::after {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/select-icon.png") no-repeat
            center;
          background-size: cover;
          width: 26px;
          height: 30px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
        }
      }
      .textarea-box {
        font-size: 24px;
        width: 100%;
        height: 190px;
        padding: 17px 22px;
        box-sizing: border-box;
        background: #fff;
        textarea {
          width: 100%;
          height: 100%;
        }
      }
      .radio-box {
        font-size: 24px;
        color: #464646;
        flex-wrap: wrap;
        .radio-item {
          position: relative;
          margin-right: 40px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &::before {
            display: inline-block;
            content: "";
            display: inline-block;
            width: 30px;
            height: 30px;
            background: url("../../../assets/images/radio-icon.png") no-repeat
              center;
            background-size: cover;
            margin-right: 15px;
            opacity: 0.4;
          }
          &.active {
            &::before {
              opacity: 1;
            }
          }
        }
      }
    }
    .from-item-address {
      color: #333333;
      .tit {
        font-size: 26px;

        font-weight: bold;
        margin-bottom: 59px;
        padding-left: 19px;
        box-sizing: border-box;
        position: relative;
        &::before {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/address-form-icon.png")
            no-repeat center;
          background-size: cover;
          width: 28px;
          height: 35px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -20px;
        }
      }
      .txt {
        font-size: 26px;
        padding-left: 13px;
        box-sizing: border-box;
        p {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
    .mb_85 {
      margin-bottom: 85px;
    }
    .mb_75 {
      margin-bottom: 75px;
    }
    .mb_100 {
      margin-bottom: 100px;
    }
    .mb_60 {
      margin-bottom: 60px;
    }
    .mb_110 {
      margin-bottom: 110px;
    }
    .mb_30 {
      margin-bottom: 30px;
    }
  }
  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
      &.disanled {
        background: #d9d9d9;
      }
    }
  }
}
</style>